import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { SimpleDialog } from './simple-dialog';

@autoinject
export class UpdateAdditionalMcNumberDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService) {
    }

    carrierId: number;
    carrierName: string;
    additionalMcNumbers: string[] = [];
    primaryMcNumber: string = "";

    activate(params) {
        this.carrierId = params[0];
        this.carrierName = params[1];
        this.additionalMcNumbers = (params[2] || "").split(',');
        if (this.additionalMcNumbers.length == 0) {
            this.additionalMcNumbers.push("");
        }
        this.primaryMcNumber = params[3];
    }

    addMcNumber() {
        console.log(this.additionalMcNumbers);
        let last = this.additionalMcNumbers[this.additionalMcNumbers.length - 1];
        if (last) {
            this.additionalMcNumbers.push("");
        }
    }

    deleteMcNumber(index) {
        if (this.additionalMcNumbers.length == 1) {
            this.additionalMcNumbers = [""];
        }
        else {
            this.additionalMcNumbers.splice(index, 1);
        }
    }

    private changedMcNumbers = [];
    public onMcNumberChanged(i: number) {
        setTimeout(() => {
            const val = i == 0 ? this.primaryMcNumber : this.additionalMcNumbers[i - 1];
            if (val) {
                this.changedMcNumbers[i] = val.toUpperCase();
            } else {
                this.changedMcNumbers[i] = undefined;
            }
        }, 0);
    }

    cancel() {
        this.controller.cancel();
    }

    async save(close = true) {
        let last = this.additionalMcNumbers[this.additionalMcNumbers.length - 1];
        if (!last) {
            this.deleteMcNumber(this.additionalMcNumbers.length - 1);
        }

        this.additionalMcNumbers = this.additionalMcNumbers
            .map(mcNumber => mcNumber.trim())
            .filter(mcNumber => mcNumber);
        
        this.primaryMcNumber = (this.primaryMcNumber || "").trim() || undefined;

        if(!this.primaryMcNumber && this.additionalMcNumbers.length > 0 ) {
            alert("Primary MC Number must be set before Additional MC Numbers are set");
            return;
        }

        if(close) {
            await this.controller.ok({
                carrierId: this.carrierId,
                primaryMcNumber: this.primaryMcNumber,
                additionalMcNumbers: this.additionalMcNumbers.join(',')
            });
        }

        // var params = {
        //     carrierId: this.carrierId,
        //     primaryMcNumber: this.primaryMcNumber,
        //     additionalMcNumbers: this.additionalMcNumbers
        // };

        // await this.api.post("Carriers", "UpdateCarrierAdditionalMcNumbers", params)
        //     .then(async () => {
        //         $["notify"]("Additional MC Numbers saved", { className: "success", position: "top center" });
        //         if (close) await this.controller.ok();
        //     }, () => {
        //         $["notify"]("Error saving additional MC Numbers", { className: "error", position: "top center" });
        //     });
    }

}